module.exports = __webpack_public_path__ + "9727cc46d1c1097ed3b6bc01865ee5fa.svg";